import "./myTasks.css";
import "../dpo-my-checklist/dpoMyChecklist.css";

import RecordHalf from "../../components/recordHalf/RecordHalf";

import { ReactComponent as ErrorIcon } from "../../assets/error.svg";
import { ReactComponent as GoodIcon } from "../../assets/good.svg";
import { ReactComponent as GreyIcon } from "../../assets/grey-icon.svg";
import { ReactComponent as WaitingIcon } from "../../assets/waiting-for-approval.svg";
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from "antd";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Select } from "antd";
import MainObligations from "../dpo-my-checklist/MainObligations";

import { isEmpty } from "lodash";
import FilterObligations from "../../components/filterObligations/FilterObligations";
import { filterObligations } from "../../util/filters";
import { sortObligationsBy } from "../../util/sorters";
import { ReactComponent as Triangle } from "../../assets/purple-triangle.svg";

const MyTasks = () => {
  const dispatchito = useDispatch();

  dayjs.extend(customParseFormat);

  const user = useSelector(state => state.user);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const originalObligations = useSelector(
    state => state.obligations.obligations
  );
  const obligations = useSelector(state => state.obligations.forms);
  const usersData = useSelector(state => state.organizations.usersData);
  const Loading = useSelector(state => state.forms.loading);
  const uniqueMainCategories = useSelector(state => state.laws.lawCategories);

  const category = useSelector(state => state.forms?.selectedCategory);
  const searchTerm = useSelector(state => state.forms?.searchTerm);
  const dueDateFrom = useSelector(state => state.forms?.dueDateFrom);
  const dueDateTo = useSelector(state => state.forms?.dueDateTo);
  const selectedAction = useSelector(state => state.forms?.selectedAction);
  const selectedAssessment = useSelector(
    state => state.forms?.selectedAssessment
  );

  const sortingTypes = ["", "asc", "desc"];
  const [sortingOrder, setSortingOrder] = useState(sortingTypes[0]);
  const [orderBy, setOrderBy] = useState("");

  //local state
  // const [category, setCategory] = useState("");
  const [scrolled, setScrolled] = useState(false);

  const { Option } = Select;
  const [obligationsInCategory, setObligationsInCategory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = currentPage === 0 ? 0 : (currentPage - 1) * 5;
  const endIndex = startIndex + 5;
  const filteredObligations =
    category ||
    searchTerm ||
    dueDateFrom ||
    dueDateTo ||
    selectedAction ||
    selectedAssessment
      ? filterObligations({
          obligationList: originalObligations,
          flag: "main",
          filters: {
            category,
            searchTerm,
            action: selectedAction,
            assessment: selectedAssessment,
            dueDateFrom,
            dueDateTo
          }
        })
      : originalObligations;
  const filteredObligationsForm =
    sortingOrder || orderBy
      ? !isEmpty(obligations) && !isEmpty(filteredObligations)
        ? sortObligationsBy(
            filteredObligations,
            "main",
            orderBy,
            sortingOrder
          )?.map(o => {
            const relevantObligation = obligations?.find(
              obl => o._id === obl._id
            );
            return relevantObligation;
          })
        : sortObligationsBy(filteredObligations, "main", orderBy, sortingOrder)
      : filteredObligations?.map(o => {
          const relevantObligation = obligations?.find(
            obl => o._id === obl._id
          );
          return relevantObligation;
        });
  const displayedItems =
    filteredObligationsForm &&
    filteredObligationsForm.slice(startIndex, endIndex);
  const currentUsersData =
    usersData?.filter(
      b => b._id === user.userId || b.role === "corporateComplianceAssessor"
    ) ?? [];

  const panelStyle = {
    marginBottom: 24,
    borderRadius: 16,
    border: "none"
  };

  const toggleOrder = () => {
    const currentIndex = sortingTypes.indexOf(sortingOrder);
    const nextIndex = (currentIndex + 1) % sortingTypes.length;
    setSortingOrder(sortingTypes[nextIndex]);
    return sortingTypes[nextIndex];
  };

  const handleChangeObl = ({ event, id, key, type }) => {
    const index = obligations?.findIndex(item => item._id === id);
    const value =
      type === "select"
        ? event
        : type === "date"
        ? new Date(event).toISOString()
        : event.target.value;

    dispatchito({
      type: "UPDATE_OBLIGATION_FORMS",
      payload: { index, value, key }
    });
  };

  const handleClearMessage = ({ event, id, key, type }) => {
    const index = obligations.findIndex(item => item._id === id);
    dispatchito({
      type: "UPDATE_OBLIGATION_FORMS",
      payload: { index, event, key }
    });
  };

  const handleSortClick = by => {
    if (orderBy !== by) {
      setSortingOrder("asc");
    } else {
      toggleOrder();
    }
    setOrderBy(by);
  };

  const countCompletedTasks = itemList =>
    itemList && itemList.filter(item => item.action === "Completed").length;
  const countPendingTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Pending").length;

  const countCompliantTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Compliant").length;
  const countPartialTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Partially").length;
  const countNonCompliantTasks = itemList =>
    itemList &&
    itemList.filter(item => item.assessment === "Non-Compliant").length;

  useEffect(() => {
    if (category !== "" && category !== undefined) {
      let oblInCategory = obligations
        ? obligations.filter(item => item.mainCategory === category)
        : [];
      setObligationsInCategory(oblInCategory);
    } else {
      setObligationsInCategory(obligations);
    }
  }, [category, obligations]);

  useEffect(() => {
    if (category !== "" && category !== undefined && !isEmpty(category)) {
      let oblInCategory = obligations
        ? obligations.filter(item => item.mainCategory === category)
        : [];
      setObligationsInCategory(oblInCategory);
    } else {
      setObligationsInCategory(obligations);
    }
  }, [category, obligations]);

  const [firstRender , setFirstRender] = useState(false);
  const targetId = useSelector(state => state.obligations.navigateId);
  useEffect(() => {
    if (targetId === 0 && scrolled) {
      if(firstRender){
        setCurrentPage(1);
        // setSortingOrder(sortingTypes[0]);
        // setOrderBy("");
      }
      setFirstRender(true);
    }
  }, [organizationId, category, searchTerm, dueDateFrom, dueDateTo, selectedAction, selectedAssessment]);

  return (
    <div className="my-tasks-container ob" id="my-tasks-container-ob-page">
      <FilterObligations
        defaultCat={""}
        organizationId={organizationId}
        sortedUniqueMainCategories={uniqueMainCategories}
        obligationType="main"
      />

      <div className="three-halfs" id="my-tasks-three-halfs">
        <RecordHalf
          id="my-tasks-record-half"
          number={countCompletedTasks(obligationsInCategory)}
          icon={<GoodIcon />}
          numberColor="#58AB5C"
          // percentage={obligations.length !== 0 ? (obligations.length-countCompliantTasks(obligations))*100/obligations.length : "NaN"}
          // percentageText="remaining to complete target"
          firstLine="Actions"
          secondLine="Completed"
          // thirdLine="this month"
          secondNumber={obligationsInCategory && obligationsInCategory.length}
          actions={true}
        />
        <RecordHalf
          id="my-tasks-record-half5"
          number={countPendingTasks(obligationsInCategory)}
          icon={<GreyIcon />}
          numberColor="grey"
          firstLine="Pending"
          secondLine="Tasks"
        />
        <RecordHalf
          id="my-tasks-record-half2"
          number={countNonCompliantTasks(obligationsInCategory)}
          icon={<ErrorIcon />}
          numberColor="#b00020"
          // percentage={obligations.length !== 0 ? (obligations.length-countCompliantTasks(obligations))*100/obligations.length : "NaN"}
          // percentageText="remaining to complete target"
          firstLine="Non-Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
        <RecordHalf
          id="my-tasks-record-half3"
          number={countPartialTasks(obligationsInCategory)}
          icon={<WaitingIcon />}
          numberColor="#E78F0B"
          // percentage={96}
          // percentageText="of target achieved"
          firstLine="Partially Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
        <RecordHalf
          id="my-tasks-record-half4"
          number={countCompliantTasks(obligationsInCategory)}
          icon={<GoodIcon />}
          numberColor="#58AB5C"
          // percentage={obligations.length !== 0 ? countCompliantTasks(obligations)*100/obligations.length : 0}
          // percentageText="of target achieved"
          firstLine="Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
      </div>

      <div className="shaded-border mt-3" id="my-tasks-shaded-border-mt-3">
        <div className="obligation-table" id="my-tasksobligation-table">
          <div className="large-titles-black" id="my-tasks-large-titles-black">
            Main Obligations
          </div>
          <Row
            className="mb-2"
            id="my-tasks-mb-2"
            gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
            style={{ marginLeft: "1.6rem", marginRight: "2rem" }}
          >
            {/* <Col span={1}>
              <span className="title-style"></span>
            </Col> */}
            {/* <Col span={1}>
              <span className="title-style">ID</span>
            </Col> */}
            <Col></Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
                // position: "relative"
              }}
              className="checklist-title-col"
              id="my-tasks-checklist-title-col"
            >
              <span
                className="title-style sortable"
                id="my-tasks-title-style"
                onClick={() => handleSortClick("law_title")}
              >
                {`Law`}
                {orderBy === "law_title" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-category-col"
              id="my-tasks-checklist-category-col"
            >
              <span
                className="title-style sortable"
                id="my-tasks-title-style-2"
                style={{ paddingLeft: "0.063rem" }}
                onClick={() => handleSortClick("mainCategory")}
              >
                Category
                {orderBy === "mainCategory" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              //span={1}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-article-col"
              id="my-tasks-checklist-article-col"
            >
              <span
                className="title-style sortable"
                id="my-tasks-title-style-3"
                onClick={() => handleSortClick("article")}
              >
                Art.
                {orderBy === "article" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              // span={1}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-paragraph-col"
              id="my-tasks-checklist-paragraph-col"
            >
              <span
                className="title-style sortable"
                id="my-tasks-title-style-4"
                style={{ paddingLeft: "0.063rem" }}
                onClick={() => handleSortClick("paragraph")}
              >
                Par.
                {orderBy === "paragraph" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-category-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-id-title-style"
                style={{ paddingLeft: "7px" }}
                onClick={() => handleSortClick("code")}
              >
                ID
                {orderBy === "code" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-obligation-col my-tasks-title"
              id="my-tasks-checklist-obligation-col"
            >
              <span
                className="title-style"
                id="my-tasks-title-style-5"
                style={{ paddingLeft: "0.438rem" }}
              >
                Obligation
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-action-col"
              id="my-tasks-checklist-action-col"
            >
              <span
                style={{ marginLeft: "0.743rem" }}
                className="title-style my-tasks"
                id="my-tasks-title-style-6"
              >
                Action
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-assessment-col"
              id="my-tasks-checklist-assessment-col"
            >
              <span
                style={{ marginLeft: "0.768rem" }}
                className="title-style my-tasks"
                id="ob-page-title-style-7"
              >
                Assessment
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-due-col"
              id="my-tasks-checklist-due-col"
            >
              <span
                style={{ marginLeft: "1.355rem" }}
                className="title-style"
                id="ob-page-title-style-9"
              >
                Due Date
              </span>
            </Col>
            {/* <Col span={2}>
              <span className="title-style">Comments</span>
            </Col> */}
            <Col
              // span={2}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="checklist-submit-col"
              id="my-tasks-checklist-submit-col"
            >
              <span className="title-style" id="title-style-9"></span>
            </Col>
          </Row>

          {displayedItems ? (
            <MainObligations
              id="my-tasks-main-obligations"
              handleChangeObl={handleChangeObl}
              handleClearMessage={handleClearMessage}
              usersData={currentUsersData || []}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              displayedItems={displayedItems}
              panelStyle={panelStyle}
              Loading={Loading}
              obligations={obligations ?? []}
              myObligations={obligations ?? []}
              obligationsInCategory={filteredObligationsForm}
              myTask={true}
              organization={user.organization}
              scrolled={scrolled}
              setScrolled={setScrolled}
            />
          ) : (
            <></>
          )}

          <div className="collapse-margin" id="my-tasks-collapse-margin">
            {" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTasks;

MyTasks.whyDidYouRender = true;
